<template lang="pug">
	section.reader-view(:class="{ 'is-embedded': isEmbed }")
		section.score-hero
			//- img(:src="overlaySrc").banner-overlay
			//- Navbar component
			nav-bar(v-if="!isEmbed")
			.container.hero-container
				//- Title
				.title-wrapper
					liveticker-title(v-if="!isEmbed")

				//- Placeholder
				.placeholder-message(v-if="status === 'none'")
					h1 Im Moment ist kein Liveticker aktiv
					p Der nächste Liveticker startet am kommenden Spieltag eine halbe Stunde vor Spielbeginn

				//- Scoreboard
				.scoreboard(v-if="!isEmbed1 && liveticker && liveticker.home && liveticker.away")
					.team.home-team
						figure.image.is-128x128.team-crest
							img(:src="homeTeamCrestURL")
						span.team-name {{ liveticker.home.club.name }}
						goal-scorers(:goals="goals.home")
					.info

						.match-info
							span.game-day(v-if="liveticker.gameDay") {{ liveticker.gameDay }}
							span.start(v-if="liveticker.start") {{ liveticker.start | formattedDateTime }}

						.scores
							span.home-score {{ liveticker.home.score }}
							span.score-divider :
							span.away-score {{ liveticker.away.score }}

						.match-status
							span.phase-name(v-if="currentPhaseName") {{ currentPhaseName }}
							game-time(
								v-if="isCurrentPhaseTimed"
								:phase="currentPhase"
							)
					.team.away-team
						figure.image.is-128x128.team-crest
							img(:src="awayTeamCrestURL")
						span.team-name {{ liveticker.away.club.name }}
						goal-scorers(:goals="goals.away")

				//- Sponsored
				.sponsored-by-header(
					v-if="liveticker && liveticker.mainSponsor"
				)
					sponsored-by(
						:sponsor="liveticker.mainSponsor"
						:sponsorLink="liveticker.mainSponsorLink"
						background="transparent"
						align="center"
						text="white"
						layout="column"
						sponsoredByText="Der Holstein Kiel Liveticker wird präsentiert von"
					)
				//- Goal sound button
				.goal-sound-button-container(
					v-if="isCurrentPhaseTimed"
				)
					.goal-sound-button
						label Torjubel
						.buttons.has-addons
							button.button.is-small.is-white(
								:class="{ 'is-outlined is-inactive': isAudioActive }"
								@click="isAudioActive = false"
							)
								span.icon.is.small: i.fas.fa-volume-slash
								span Aus
							button.button.is-small.is-white(
								:class="{ 'is-outlined is-inactive': !isAudioActive }"
								@click="isAudioActive = true"
							)
								span.icon.is.small: i.fas.fa-volume
								span An

		section.section.content
			.container
				.level.is-mobile.status-level
					//- Liveticker connection status
					.level-left
							connection-status(
								:status="status"
								:connection-status="connectionStatus"
							)

					//- FANSHOP button for embed layout
					.level-right(v-if="isEmbed")
						a(href="https://holstein-fanshop.de/" target="_blank").button.is-primary.fanshop-button
							i.fas.fa-shopping-cart
							span ZUM FANSHOP

				//- Tabs for mobile (switch between columns)
				.mobile-tabs(v-if="isMobile && !isEmbed1")
					.tabs
						ul
							li(v-if="canShowTicker" :class="{ 'is-active' : isTickerTabSelected }")
								a(@click="selectedTab = 'ticker'") Ticker
							li(v-if="canShowMatchInfo" :class="{ 'is-active' : isMatchInfoTabSelected }")
								a(@click="selectedTab = 'match-info'") Spiel-Infos
							li(v-if="canShowAnyLineup" :class="{ 'is-active' : selectedTab === 'lineup' }")
								a(@click="selectedTab = 'lineup'") Aufstellungen
							li(v-if="canShowStandings" :class="{ 'is-active' : selectedTab === 'standings' }")
								a(@click="selectedTab = 'standings'") Blitztabelle

				.columns
					//- Main column
					.column.is-two-thirds(
						v-show="isTickerVisible"
					)
						//- Liveticker
						liveticker-reader(
							v-if="canShowTicker"
							v-show="isTickerVisible"
							:liveticker="liveticker"
							:messages="orderedMessages"
							:main-team-crest="mainTeamCrestURL"
							:opponent-team-crest="opponentTeamCrestURL"
						)
					//- Sidebar
					.column.sidebar
						sponsor-banner(
							v-if="liveticker && liveticker.sidebarSponsor"
							:sponsor="liveticker.sidebarSponsor"
							:sponsor-link="liveticker.sidebarSponsorLink"
							fullwidth
						)
						match-info(
							v-if="canShowMatchInfo"
							v-show="isMatchInfoVisible"
							:referee="liveticker.referee"
							:visitors="liveticker.visitors"
							:is-visitors-estimate="liveticker.isVisitorsEstimate"
							:location="liveticker.location"
							:game-day="liveticker.gameDay"
							:start="liveticker.start"
						)
						lineup(
							v-if="canShowHomeLineup"
							v-show="isHomeLineupVisible"
							:club="liveticker.home.club"
							:lineup="inflatedHomeLineup"
							:actions="actionsByPlayerID"
						)
						lineup(
							v-if="canShowAwayLineup"
							v-show="isAwayLineupVisible"
							:club="liveticker.away.club"
							:lineup="inflatedAwayLineup"
							:actions="actionsByPlayerID"
						)

						standings-table(
							v-show="isStandingsVisible"
							v-if="liveticker"
						)

</template>

<script>
import NavBar from '@/components/NavBar'

import ConnectionStatus from '@/components/ConnectionStatus'
import LivetickerReader from '@/components/LivetickerReader'
import MatchInfo from '@/components/MatchInfo'
import GoalScorers from '@/components/GoalScorers'
import StandingsTable from '@/components/StandingsTable'

import Lineup from '@custom-media/ksv-liveticker-shared/src/components/Lineup'
import LivetickerTitle from '@custom-media/ksv-liveticker-shared/src/components/LivetickerTitle'
import SponsorBanner from '@custom-media/ksv-liveticker-shared/src/components/SponsorBanner'
import GameTime from '@custom-media/ksv-liveticker-shared/src/components/GameTime'
import SponsoredBy from '@custom-media/ksv-liveticker-shared/src/components/SponsoredBy'
import feathersClient from '@/feathers-client'

import mediaMixin from '@custom-media/ksv-liveticker-shared/src/mixins/mediaMixin'
import phaseMixin from '@custom-media/ksv-liveticker-shared/src/mixins/phaseMixin'

import { Howl } from 'howler'
import overlaySrc from '@/assets/img/scoreboard-overlay-2.png'

const subscriptionsService = feathersClient.service('subscriptions')
const livetickersService = feathersClient.service('livetickers')
const messagesService = feathersClient.service('messages')

const primaryTeamGoalAudio = new Howl({
	src: ['/audio/goal-primary-team.mp3']
})

export default {
	mixins: [mediaMixin, phaseMixin],
	components: {
		NavBar,
		LivetickerReader,
		ConnectionStatus,
		MatchInfo,
		Lineup,
		LivetickerTitle,
		SponsorBanner,
		GameTime,
		GoalScorers,
		SponsoredBy,
		StandingsTable
	},
	computed: {
		// Map liveticker message order to messages
		orderedMessages () {
			if (this.liveticker === null || this.messages === null) {
				return []
			}
			return [...this.liveticker.messages].reverse()
				.map(mid => this.messages.find(m => m._id === mid))
				.filter(m => m !== undefined)
		},
		// Inflate the lineup players for the home team
		inflatedHomeLineup () {
			const deflatedLineup = this.liveticker.home.lineup
			const currentLineup = deflatedLineup.map(l => {
				return { players: l.players.map(pid => this.liveticker.home.club.players.find(cp => cp._id === pid)) }
			})
			return currentLineup
		},
		// Inflate the lineup players for the away team
		inflatedAwayLineup () {
			const deflatedLineup = this.liveticker.away.lineup
			const currentLineup = deflatedLineup.map(l => {
				return { players: l.players.map(pid => this.liveticker.away.club.players.find(cp => cp._id === pid)) }
			})
			return currentLineup
		},
		// Get the home team crest url
		homeTeamCrestURL () {
			if (this.liveticker && this.liveticker.home && this.liveticker.home.club && this.liveticker.home.club.crest) {
				return this.getMediaThumbnailURL(this.liveticker.home.club.crest)
			} else {
				return null
			}
		},
		// Get the away team crest url
		awayTeamCrestURL () {
			if (this.liveticker && this.liveticker.away && this.liveticker.away.club && this.liveticker.away.club.crest) {
				return this.getMediaThumbnailURL(this.liveticker.away.club.crest)
			} else {
				return null
			}
		},
		mainTeamCrestURL () {
			return this.isMainClubHome ? this.homeTeamCrestURL : this.awayTeamCrestURL
		},
		opponentTeamCrestURL () {
			return this.isMainClubHome ? this.awayTeamCrestURL : this.homeTeamCrestURL
		},
		// Get the current phase of the liveticker
		currentPhase () {
			if (!this.liveticker || !this.liveticker.phases || !Array.isArray(this.liveticker.phases) || this.liveticker.phases.length === 0) {
				return null
			}
			return this.liveticker.phases[this.liveticker.phases.length - 1]
		},
		// Check if the current phase is timed
		isCurrentPhaseTimed () {
			if (!this.currentPhase || !this.currentPhase.key) {
				return false
			}
			return this.isPhaseTimed(this.currentPhase.key)
		},
		// Get the readable name of the current phase
		currentPhaseName () {
			var p = this.currentPhase
			if (p && p.key) {
				return this.getReadablePhaseName(p.key)
			} else {
				return null
			}
		},
		isMainClubHome () {
			return this.liveticker.home && this.liveticker.home.club && this.liveticker.home.club.isMain
		},
		// Main club id
		mainClub () {
			if (this.liveticker) {
				if (this.liveticker.home && this.liveticker.home.club && this.liveticker.home.club.isMain) {
					return this.liveticker.home.club._id
				} else if (this.liveticker.away && this.liveticker.away.club && this.liveticker.away.club.isMain) {
					return this.liveticker.away.club._id
				}
			}
			return '' // TODO: mainClub default value?
		},
		// Opponent club id
		opponentClub () {
			if (this.liveticker) {
				if (this.liveticker.home && this.liveticker.home.club && !this.liveticker.home.club.isMain) {
					return this.liveticker.home.club._id
				} else if (this.liveticker.away && this.liveticker.away.club && !this.liveticker.away.club.isMain) {
					return this.liveticker.away.club._id
				}
			}
			return '' // TODO: mainClub default value?
		},
		// Main sponsor media
		mainSponsor () {
			return this.liveticker && this.liveticker.mainSponsor ? this.liveticker.mainSponsor : null
		},
		// Main sponsor url
		mainSponsorLink () {
			return this.liveticker && this.liveticker.mainSponsorLink ? this.liveticker.mainSponsorLink : null
		},
		// Collect actions of a player by the player id
		actionsByPlayerID () {
			if (!this.messages) { return {} }
			var actions = {}
			function pushAction (player, action) {
				if (player && player._id && action) {
					if (actions[player._id] === undefined) {
						actions[player._id] = [action]
					} else {
						actions[player._id].push(action)
					}
				}
			}
			this.messages.forEach(m => {
				if (m.action && m.players && m.players.length > 0) {
					switch (m.action) {
					case 'own-goal':
					case 'goal':
					case 'yellow-card':
					case 'yellow-red-card':
					case 'red-card':
						const player = m.players[0]
						pushAction(player, m.action)
						break
					case 'substitution':
						const playerOut = m.players[0]
						const playerIn = m.players[1]
						pushAction(playerOut, 'substitution-out')
						pushAction(playerIn, 'substitution-in')
						break
					}
				}
			})
			return actions
		},
		// Collect goals by team
		goals () {
			var goals = { home: [], away: [] }
			if (!this.messages || !this.liveticker || !this.liveticker.home || !this.liveticker.home.club || !this.liveticker.away || !this.liveticker.away.club) {
				return goals
			}

			this.messages.forEach(m => {
				if (m.action && (m.action === 'goal' || m.action === 'own-goal')) {
					var goal = {
						time: m.time,
						action: m.action,
						goalType: m.goalType || 'default',
						player: (m.players && m.players.length >= 1) ? m.players[0] : null
					}
					if (m.club === this.liveticker.home.club._id) {
						goals.home.push(goal)
					} else if (m.club === this.liveticker.away.club._id) {
						goals.away.push(goal)
					}
				}
			})
			return goals
		},
		// Check if app is in mobile mode
		isMobile () {	return this.$mq && this.$mq === 'mobile' },
		isEmbed () {
			return this.isEmbed1 || this.isEmbed2
		},
		isEmbed1 () {
			return !this.isEmbed2 &&
				window &&
				window.location &&
				window.location.search &&
				window.location.search.includes('layout=embed')
		},
		isEmbed2 () {
			return window &&
				window.location &&
				window.location.search &&
				window.location.search.includes('layout=embed2')
		},

		// Determine tab visibility
		canShowTicker () { return !!this.liveticker },
		isTickerTabSelected () { return this.selectedTab === 'ticker' },
		isTickerVisible () { return this.canShowTicker && (this.isMobile === false || this.isTickerTabSelected) },

		canShowMatchInfo () { return !!this.liveticker },
		isMatchInfoTabSelected () { return this.selectedTab === 'match-info' },
		isMatchInfoVisible () { return this.canShowMatchInfo && (this.isMobile === false || this.isMatchInfoTabSelected) },

		canShowHomeLineup () { return this.liveticker && this.liveticker.home && this.liveticker.home.club && this.liveticker.home.lineup && this.liveticker.home.lineup.length > 0 },
		canShowAwayLineup () { return this.liveticker && this.liveticker.away && this.liveticker.away.club && this.liveticker.away.lineup && this.liveticker.away.lineup.length > 0 },
		canShowAnyLineup () { return this.canShowHomeLineup || this.canShowAwayLineup },
		isLineupTabSelected () { return this.selectedTab === 'lineup' },
		isHomeLineupVisible () { return this.canShowHomeLineup && (this.isMobile === false || this.isLineupTabSelected) },
		isAwayLineupVisible () { return this.canShowAwayLineup && (this.isMobile === false || this.isLineupTabSelected) },

		canShowStandings () { return !!this.liveticker },
		isStandingsTabSelected () { return this.selectedTab === 'standings' },
		isStandingsVisible () { return this.canShowStandings && (this.isMobile === false || this.isStandingsTabSelected) }
	},
	data () {
		return {
			liveticker: null,
			messages: null,
			status: 'loading',
			connectionStatus: null,
			isAudioActive: false,
			selectedTab: 'ticker',
			overlaySrc
		}
	},
	created () {
		this.initializeLiveticker()
		this.initializeConnectionStatus()
	},
	methods: {
		// Update the general status of the liveticker
		async updateLivetickerStatus () {
			try {
				var result = await subscriptionsService.create({
					public: true
				})
				if (result.status === 'public') {
					this.status = 'public'
					this.liveticker = result.liveticker
					this.messages = result.messages
				} else if (result.status === 'upcoming') {
					this.status = 'upcoming'
					this.liveticker = null
					this.messages = null
				} else if (result.status === 'none') {
					this.status = 'none'
					this.liveticker = null
					this.messages = null
				}
			} catch (error) {
				if (error.code && error.code === 408) { // Timeout
					console.error('Timeout error:', error.message)
				} else {
					throw error
				}
			}
		},
		// Initialize the liveticker by getting the initial liveticker state listening to events
		async initializeLiveticker () {
			await this.updateLivetickerStatus()

			livetickersService.on('published', (livetickerID) => {
				this.updateLivetickerStatus()
			})

			livetickersService.on('unpublished', (livetickerID) => {
				this.liveticker = null
				this.messages = null
				this.updateLivetickerStatus()
			})

			messagesService.on('unpublished', (data) => {
				if (!this.messages || !Array.isArray(this.messages)) {
					return
				}
				var i = this.messages.findIndex(m => m._id === data.message)
				if (i !== -1) {
					this.messages.splice(i, 1)
				}
			})
			livetickersService
				.on('patched', this.handleLivetickerUpdate)
				.on('updated', this.handleLivetickerUpdate)

			messagesService
				.on('created', this.handleMessageCreated)
				.on('updated', m => {
					if (!this.messages || !Array.isArray(this.messages)) {
						return
					}
					var i = this.messages.findIndex(me => me._id === m._id)
					if (i !== -1) {
						this.messages.splice(i, 1, m)
					} else {
						this.messages.push(m)
					}
				})
				.on('patched', m => {
					if (!this.messages || !Array.isArray(this.messages)) {
						return
					}
					var i = this.messages.findIndex(me => me._id === m._id)
					if (i !== -1) {
						this.messages.splice(i, 1, m)
					} else {
						this.messages.push(m)
					}
				})
				.on('removed', m => {
					if (!this.messages || !Array.isArray(this.messages)) {
						return
					}
					var i = this.messages.findIndex(me => me._id === m._id)
					if (i !== -1) {
						this.messages.splice(i, 1)
					}
				})
		},

		// Handle a created message
		handleMessageCreated (message) {
			if (!message) { return }
			if (this.messages && Array.isArray(this.messages)) {
				this.messages.push(message)
			}

			if (message.action === 'goal') {
				// Tor
				if (message.club === this.mainClub) {
					this.handleEvent('primary-goal')
				} else if (message.club === this.opponentClub) {
					this.handleEvent('opponent-goal')
				}
			} else if (message.action === 'own-goal') {
				// Eigentor
				if (message.club === this.mainClub) {
					this.handleEvent('primary-own-goal')
				} else if (message.club === this.opponentClub) {
					this.handleEvent('opponent-own-goal')
				}
			}
		},

		// Handle an update to the liveticker
		handleLivetickerUpdate (liveticker) {
			if (this.liveticker !== null) {
				this.liveticker = liveticker
			}
		},

		initializeConnectionStatus () {
			feathersClient.io.on('connect', () => { this.connectionStatus = 'connected' })
			feathersClient.io.on('reconnecting', () => { this.connectionStatus = 'reconnecting' })
			feathersClient.io.on('reconnect', () => {
				window.setTimeout(() => {
					this.updateLivetickerStatus()
				}, Math.random() * 1000)
			})
		},

		handleEvent (sound) {
			switch (sound) {
			case 'primary-goal': this.playPrimaryTeamGoalAudioSound(); break
			case 'opponent-own-goal': this.playPrimaryTeamGoalAudioSound(); break
			}
		},

		playPrimaryTeamGoalAudioSound () {
			if (!this.isAudioActive) { return }
			try {
				primaryTeamGoalAudio.play()
			} catch (error) {
				console.log('Could not play primary team audio: ' + error)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	@import "@/assets/scss/bulma-variables.scss";
	section.score-hero {
		background-image: url('../assets/img/scoreboard-background-clean.jpg');
		background-size: cover;
    background-position: center top;
		position: relative;
		@media screen and (min-width: 768px) {
			background-image: url('../assets/img/scoreboard-background-1.jpg');
		}

		.banner-overlay {
			position: absolute;
			right: 0;
			bottom: 0;
			top: 0;
			max-height: 100%;
			// width: 20vw;
		}

		.audio-button {
			position: absolute;
			top: 1.1em;
			right: 0;
			i {
				margin-right: 0.5em;
			}

			@media screen and (max-width: 768px) {
				position: initial;
				margin-top: 0.5em;
			}
		}
	}
	section.section.content {
		background: url('../assets/img/ksv-section-hintergrund.jpg');
		background-size: 100%;

		.status-level {
			padding: 0.75rem;
			margin-bottom: 0.5em;
			.level-left {
				flex-shrink: 1;
			}

			.fanshop-button {
				i {
					margin-right: 0.5em;
				}
			}
		}

		@media screen and (max-width: 768px) {
			padding: 0rem 0rem;
			.columns {
				margin-left: 0;
				margin-right: 0;
			}
		}
	}
	.hero-container {
		padding-top: 80px;
		@media screen and (max-width: 524px) {
			padding-top: 4%;
		}
	}
	.is-embedded .hero-container {
		padding-top: 0;
	}

	.placeholder-message {
		text-align: center;
		color: $white;
		text-shadow: 2px 2px $primary;
		padding: 2em 1em 3em 1em;
		h1 {
			font-size: 2em;
		}
		p {
			font-size: 1.25em;
		}

		@media screen and (max-width: 524px) {
			padding: 3em 1em;
			h1 {
				font-size: 1.25em;
			}
			p {
				font-size: 0.9em;
			}
		}
	}

	// Scoreboard (scores, crests)
	.scoreboard {
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 2em;
		padding-bottom: 2em;
		@media screen and (max-width: 768px) {
			padding-bottom: 1em;
			padding-top: 1em;
		}
		.team {
			font-size: 2em;
			color: $white;
			font-weight: bold;
			text-shadow: 2px 2px $primary;
			padding: 0 1em;
			flex-grow: 0.4;
			flex-shrink: 0;
			width: 40%;
			display: flex;
			flex-direction: column;
			align-items: center;
		}
		.info {
			flex-grow: 0.2;
			text-align: center;
			color: white;

			.match-info {
				display: flex;
				flex-direction: column;
				justify-content: center;
				font-size: 1.125em;
			}
		}
		.scores {
			font-size: 5em;
			color: $white;
			font-weight: bold;
			text-shadow: 2px 2px $primary;
			display: flex;
			align-items: center;
			justify-content: center;
			.score-divider {
				margin-left: 0.2em;
				margin-right: 0.2em;
				font-size: 0.5em;
			}
		}
		.phase-name {
			font-size: 1.25em;
		}
		.game-time {
			color: white;
			font-size: 2em;
		}

		@media screen and (max-width: 768px) {
			.team {
				font-size: 0.9em;
				padding: 0 0.4em;
				.team-crest.is-128x128 {
					width: 64px;
					height: 64px;
				}
				width: 30%;
			}
			.scores {
				font-size: 2.25em;
			}
			.info .match-info {
				font-size: 0.6em;
				display: none;
			}
			.match-status {
					.phase-name  {
						font-size: 0.7em;
					}
					.game-time {
						font-size: 0.9em;
					}
			}
		}
	}

	.sponsored-by-header {
		padding-bottom: 1em;
		.sponsored-by {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			&::v-deep .sponsored-by-text {
				font-size: 1em;
				font-weight: bold;
				text-shadow: 1px 1px $primary;
				@media screen and (max-width: 768px) {
					font-size: 0.8em;
				}
			}
		}
	}

	.sidebar {
		.match-info,
		.sponsor-banner,
		.standings,
		.lineup {
			margin-bottom: 1em;
		}
	}

	.goal-sound-button-container {
		display: flex;
    justify-content: flex-end;
    padding: 0.75em;
		.goal-sound-button {
			display: flex;
			button.is-inactive {
				color: #b5b5b5;
			}
			label {
				margin-right: .5em;
				color: $white;
			}
		}
	}

	.mobile-tabs {
		margin-bottom: 1em;
		@media screen and (min-width: 769px) {
			visibility: hidden;
		}
	}

	.tabs ul {
		margin: 0;
		padding-left: 0.75em;
		padding-right: 0.75em;
	}
	.tabs li.is-active a {
		border-bottom-color: $primary;
		color: $primary;
	}

</style>
